module.exports = __webpack_public_path__ + "static/media/pt_logo_color.d6c74677.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/header/pt_logo_color.svg
// module id = 274
// module chunks = 0